import { ComponentStyleConfig, theme as baseTheme } from '@chakra-ui/theme'

import { primaryColor } from '../foundations/primaryColor'

import { Text } from './text'

const { input } = primaryColor

// You can also use the more specific type for
// a single part component: ComponentSingleStyleConfig

// when using ComponentStyleConfig you need specify when component your select
// example =  field | addon |  element

export const Input: ComponentStyleConfig = {
  baseStyle: {
    field: {
      ...baseTheme.components.Input.baseStyle,
      color: input.bgColorText,
      _placeholder: {
        color: input.bgPlaceholderColor,
        opacity: 1,
        ...Text.variants?.SM
      },
    }
  },
  variants: {
    primary: props => ({
      field: {
        ...baseTheme.components.Input.variants.filled(props),
        px: '1.5rem',
        bg: input.bgColor,
        rounded: 'full',
        ...Text.variants?.SM,
        shadow: 9,
        _disabled: {
          bg: input.bgDisabledColor,
          color: input.bgDisabledColorText
        },
        _focus: {
          borderColor: input.bgBorderColor,
          borderWidth: 1,
        },
        _invalid: {
          borderColor: 'red.300',
          borderWidth: 1,
        },
      }
    }),
    select: {
      baseStyle: {
        _focus: {
          borderColor: 'transparent',
        },
      },
    },
  },
  defaultProps: {
    variant: 'primary',
  },
}
